export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PageHeader.vue?vue&type=template&id=79ac872a&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PageHeader.vue?vue&type=template&id=79ac872a&scoped=true&
// module id = 210
// module chunks = 0